export default "__VITE_ASSET__b6bcf19d__"